// Featured-content URL rules, mirrored on the BE (FeaturedContentUrlValidators.ts) so the admin form
// blocks the same data-entry mistakes the write path rejects.

function parseHttps(raw: string): URL | null {
  try {
    const url = new URL(raw);
    return url.protocol === "https:" ? url : null;
  } catch {
    return null;
  }
}

const normalizeHost = (url: URL): string => url.hostname.replace(/^www\./, "").toLowerCase();

// True only for a specific TikTok video — not a profile or arbitrary site. Instagram is
// rejected: reels have no public embed playback and no direct mp4, so they render on the
// creator-hub feed as dead black cards. Re-allow only when the BE accepts IG again.
export function isFeaturedContentUrl(raw: string): boolean {
  const url = parseHttps(raw);
  if (!url) return false;
  const host = normalizeHost(url);
  const path = url.pathname;
  if (host === "tiktok.com" || host.endsWith(".tiktok.com")) {
    const isShortLink = host === "vt.tiktok.com" || host === "vm.tiktok.com";
    return /\/video\/\d+/.test(path) || (isShortLink && path.length > 1) || /^\/t\//.test(path);
  }
  return false;
}

// A comment is per-item commentary; a value that is nothing but a URL is the "real video pasted into the wrong box" mistake.
export function isBareUrl(text: string): boolean {
  return /^https?:\/\/\S+$/i.test(text.trim());
}
